export const INITIAL_TOP_INPUT_WIDTH = 193;
export const INITIAL_BOT_INPUT_WIDTH = 161;
export const EMPTY = "";
